import React from 'react'
import "./Successfull_lottie.css";
import Lottie from 'react-lottie';
import * as animationData from './Successfull_Lottie.json';

export default function Successfull_lottie() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        <>
            <section className='main'>
                <div className='Successfull_Lottie_icon'>
                    <Lottie className="me-auto"
                        options={defaultOptions}

                    />
                </div>
            </section>
        </>
    )
}
